<!-- AI案例 -->
<template>
  <div class="case">
    <h4 class="current">您的位置：<router-link to="/home">首页 </router-link> &gt;资讯中心</h4>
    <div class="article">
      <h5>从绩效考核指标看三级综合医院功能定位导向</h5>
      <h6>2019-02-08 &nbsp;&nbsp;&nbsp;&nbsp;来源：健康界</h6>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;经常看到有人说，绩效考核是指挥棒。期待已久的三级公立医院考核具体政策终于出台了。2019年1月16日《国务院办公厅关于加强三级公立医院绩效考核工作的意见》（国办发〔2019〕4号）发布，
        在指导思想上明确提出“引导三级公立医院进一步落实功能定位，推进分级诊疗制度建设”。在这个绩效考核的文件中一共有55个三级（具体）指标，其中涉及功能定位指标7个，其中有4个指标与手术相关：出院患者手术占比、日间手术占择期手术比、出院患者微创手术占比和出院患者四级手术比例。另外3个指标：反映门诊住院人次比、转下级医疗机构诊疗人次比和特需医疗服务人次比。
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对于各级各类医疗机构诊疗服务功能定位，《国务院办公厅关于推进分级诊疗制度建设的指导意见》（国办发〔2015〕70号）明确指出：“城市三级医院主要提供急危重症和疑难复杂疾病的诊疗服务。”从这个定位来看，功能定位指标中只有出院患者四级手术比例一个指标符合，其他指标均不能确切反映分级诊疗对于三级医院的功能定位要求。出院患者手术占比，不是医院功能定位的精确指标，而是综合医院手术科室与非手术科室的平衡发展考核指标。而日间手术占比和微创手术占比更不能确切反映疾病的危重程度，用于二级或一级医院考核也许才是确切的。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;而目前出台的考核指标，将有可能把三级公立综合医院导向外科专科手术发展的方向，并有可能诱导过度手术治疗和追求微创手术治疗的方向，增加患者的手术费用负担，加大手术治疗的风险，更可能会影响到非手术科室的健康发展。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其实，重症监护（ICU、CCU）患者占比、四级手术患者占比、抢救患者占比和急诊占比才能较为全面反映三级公立医院的分级诊疗功能定位。如果要运用手术的概念来考核三级医院的功能定位，还有一个指标是可以用的，即手术病种的非手术治疗率。在当下的分科诊疗到病种诊疗的融合型诊疗趋势中，能不手术的应该尽量不手术，譬如胃溃疡、癌症等诸多过去都需要手术的病种，由于专科病种的中心化医疗模式，而可以采用非手术的保守治疗模式。这才是真正体现三级医院疑难与复杂疾病的诊疗服务水平。<br />
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对于三级公立医院，反映分级诊疗功能定位的指标中，还有一个指标被忽略了，这个指标不是下转了多少病人，而是在三级医院中有多少医保病人是上转的。上转医保病人数比（人次）表面上看是取决于下级医院，其实也是取决于三级医院自身。分级诊疗一定是上下联动，而不能单向管理，而从这次的考核指标来看，上级医院只负责下转，下级医院只负责上转。而三级医院作为分级诊疗的顶层机构，除了自费医疗的特殊病人，医保住院病人都应该是上转的，如果自行接收医保病人，下级上转的政策还有可能执行得下去吗？<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;特需医疗服务占比反映的是公立医院的公益性定位，公立医院的公益性应该体现在两个方面，一个是特殊医疗服务项目在医院整个医疗服务项目中的比重，这个指标可能就是目前考核指标中所设计的，这个是需要有严格限制的，对公立医院提供特殊医疗服务规定一般不得超过10%。公立医院的公益性还体现在另一个方面，即三级医院的资源用于自费病人的情况，公立医院的自费病人越多，从一个角度说明了医疗保险基金的节约，同时也满足了人民群众享受更好医疗服务的需求。笔者以为，对于自费病人的服务，从体现三级公立医院的公益性来讲，可以大加鼓励，只要不影响到医保急危重症病人的诊疗，应该充分发挥公立三级医院的资源优势。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医疗保险政策的前提不是自行选择就诊的设计，这个制度的前提就是指定的医疗机构就诊，只有自费病人才有自由选择就诊机构的权利。这种医保定点、自费自由的就诊制度，才能让基本医疗和特殊医疗有效区分，也才能让市场医疗健康发展，让医保基金有效利用与节约。那些又想享受高级与快捷医疗服务的人，不可能又能享受基本医疗保险报销的服务，预约医疗与保险医疗合一，自费医疗与便捷就医合一，这样才能让医疗保险与自费医疗相协调。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;因此，三级医院的绩效考核指标设计，从功能定位指标来看，还需要进一步科学化、精细化，尤其不能把三级综合医院变成了清一色的手术外科医院。如果真的是那样，不仅仅是对于患者，对于广大的非手术科室医务人员也是不公平的。<br />
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
